import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect } from "react";
import { usePopper } from "react-popper";
import classNames from "classnames";
import { nanoid } from "nanoid";
import { Text } from "../Text/Text";
export const Tooltip = ({ children, className, isDark, bodySlot, modifiers, enableFocus, isOpen = false, label = "Tooltip", delay = 400, placement = "bottom", strategy = "absolute", // popper default
id, ...rest }) => {
    let timeout;
    const [tooltipElement, setTooltipElement] = useState(null);
    const [referenceElement, setReferenceElement] = useState(null);
    const [arrowElement, setArrowElement] = useState(null);
    const [displayTooltip, setDisplayTooltip] = useState(false);
    const [tooltipId] = useState(id || `eds-tooltip--${nanoid(10)}`);
    const showTooltip = () => {
        timeout = setTimeout(() => {
            setDisplayTooltip(true);
        }, delay);
    };
    const hideTooltip = () => {
        clearInterval(timeout);
        setDisplayTooltip(false);
    };
    const { styles, attributes } = usePopper(referenceElement, tooltipElement, {
        placement,
        strategy,
        modifiers: [
            {
                name: "offset",
                options: {
                    offset: [0, 8],
                },
            },
            {
                name: "flip",
                options: {
                    fallbackPlacements: ["bottom", "top"],
                },
            },
            { name: "arrow", options: { element: arrowElement, padding: 8 } },
            ...(modifiers !== null && modifiers !== void 0 ? modifiers : []),
        ],
    });
    // Accessibility: Close tooltip on escape key press
    useEffect(() => {
        document.addEventListener("keydown", e => {
            if (e.key === "Escape") {
                setDisplayTooltip(false);
            }
        });
        return () => {
            document.removeEventListener("keydown", e => e);
        };
    }, [displayTooltip]);
    const tooltipClasses = classNames("eds-tooltip", isDark ? "eds--dark" : "eds--light", className);
    const tabIndexProps = enableFocus ? { tabIndex: 0 } : {};
    return (_jsxs(_Fragment, { children: [_jsx("span", { className: "eds-tooltip__anchor", ...tabIndexProps, ref: setReferenceElement, onMouseEnter: showTooltip, onMouseLeave: hideTooltip, onFocus: showTooltip, onBlur: hideTooltip, children: React.cloneElement(children, {
                    "aria-haspopup": "dialog",
                    "aria-controls": tooltipId,
                    "aria-expanded": displayTooltip ? "true" : "false",
                    "aria-describedby": tooltipId,
                    "aria-label": label,
                }) }), (isOpen || displayTooltip) && (_jsxs("div", { id: tooltipId, className: tooltipClasses, role: "tooltip", title: label, ref: setTooltipElement, style: styles.popper, ...attributes.popper, ...rest, children: [_jsx("div", { className: "eds-tooltip__body", "aria-live": "polite", children: typeof bodySlot === "string" ? (_jsx(Text, { as: "p", font: "body-3", children: bodySlot })) : (bodySlot) }), _jsx("div", { className: "eds-tooltip__arrow", ref: setArrowElement, style: styles.arrow, ...attributes.arrow })] }))] }));
};
